import { render, staticRenderFns } from "./MSLandingLeft.vue?vue&type=template&id=3115c42e&scoped=true"
import script from "./MSLandingLeft.vue?vue&type=script&lang=js"
export * from "./MSLandingLeft.vue?vue&type=script&lang=js"
import style0 from "./MSLandingLeft.vue?vue&type=style&index=0&id=3115c42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.93.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115c42e",
  null
  
)

export default component.exports